/** Kinetiq StakingAccountant — `kHYPEToHYPE(uint256)` returns HYPE
 *  owed for a given kHYPE amount. Pass `1e18` to get the 1e18-scaled
 *  HYPE-per-kHYPE rate. */
export const KinetiqStakingAccountantAbi = [
  {
    name: 'kHYPEToHYPE',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'kHYPEAmount' }],
    outputs: [{ type: 'uint256' }],
  },
] as const
